// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/swiper/css/swiper.css
// module id = 179
// module chunks = 1